import type { EMessageChannel } from 'src/services/api';
import { isSupportedSignatureChannel, type GetUserSettingsResponse } from 'src/services/api/users/settings/types';

/**
 * Signature text is stored as a plain suffix embedded in the reply input rather than
 * as separate state, so callers that overwrite the reply input (e.g. smart replies)
 * need this to re-append it.
 */
export const getFormattedSignature = (
    channel: EMessageChannel,
    userSettings: GetUserSettingsResponse['settings']
): string => {
    const signature = isSupportedSignatureChannel(channel) ? userSettings.signatures[channel] : undefined;
    return signature?.is_enabled ? `\n---\n${signature.text}` : '';
};
